import { useState, useEffect } from 'react';

interface SplashScreenProps {
  onFinish: () => void;
}

export default function SplashScreen({ onFinish }: SplashScreenProps) {
  const [phase, setPhase] = useState<'enter' | 'hold' | 'exit'>('enter');
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    const holdTimer  = setTimeout(() => setPhase('hold'),    600);
    const textTimer  = setTimeout(() => setTextVisible(true), 900);
    const exitTimer  = setTimeout(() => setPhase('exit'),   2200);
    const doneTimer  = setTimeout(() => {
      window.dispatchEvent(new CustomEvent('splashFinished'));
      onFinish();
    }, 3000);

    return () => {
      clearTimeout(holdTimer);
      clearTimeout(textTimer);
      clearTimeout(exitTimer);
      clearTimeout(doneTimer);
    };
  }, [onFinish]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-white"
      style={{
        opacity: phase === 'exit' ? 0 : 1,
        transition: phase === 'exit' ? 'opacity 0.8s ease' : 'none',
        pointerEvents: phase === 'exit' ? 'none' : 'auto',
      }}
    >
      <div className="flex flex-col items-center gap-6">
        {/* Logo */}
        <div
          style={{
            transform:
              phase === 'enter' ? 'scale(0.72)' : 'scale(1)',
            opacity: phase === 'enter' ? 0 : 1,
            transition:
              phase === 'enter'
                ? 'transform 0.65s cubic-bezier(0.22,1,0.36,1), opacity 0.45s ease'
                : 'none',
          }}
        >
          <img
            src="https://static.readdy.ai/image/2971b814dc462dd4b8fae3beb50e2175/fe51ca6d464359b6727fc714a105c082.png"
            alt="mecena Intercom"
            className="h-10 w-auto object-contain"
          />
        </div>

        {/* Divider */}
        <div
          className="w-px bg-gray-200 overflow-hidden"
          style={{
            height: textVisible ? '32px' : '0px',
            opacity: textVisible ? 1 : 0,
            transition: 'height 0.6s ease, opacity 0.6s ease',
          }}
        />

        {/* Text */}
        <div
          className="flex flex-col items-center gap-2 text-center"
          style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? 'translateY(0)' : 'translateY(10px)',
            transition: 'opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s',
          }}
        >
          <p
            className="text-sm tracking-widest text-gray-700"
            style={{ fontFamily: "'Noto Serif JP', serif", letterSpacing: '0.18em' }}
          >
            意味を設計し、価値を創る。
          </p>
          <p
            className="text-xs italic text-gray-400"
            style={{ fontFamily: "'EB Garamond', serif", letterSpacing: '0.06em' }}
          >
            Shaping meaning. Creating value. With society.
          </p>
        </div>
      </div>
    </div>
  );
}
